import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as solidIcons from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';

const DynamicFaIcon = ({ iconName }) => {
  if (typeof iconName === 'string' && iconName.startsWith('<svg')) {
    return <div dangerouslySetInnerHTML={{ __html: iconName }} />;
  }

  const icon = solidIcons[iconName];

  if (!icon) {
    return null; // Or return a default icon
  }

  return <FontAwesomeIcon icon={icon} />;
};

DynamicFaIcon.propTypes = {
  iconName: PropTypes.string.isRequired,
};

export default DynamicFaIcon;